{
  "chart": {
    "how-to-measure": "Comment mesurer",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Sélectionnez votre taille, nous vous préviendrons dès qu'il sera de nouveau en stock",
    "image-nav-previous": "Image précédente",
    "image-nav-next": "Image suivante",
    "image-nav-position": "{{current}} / {{total}}"
  },
  "page": {
    "plans": {
      "try-now": "Essayer maintenant",
      "what-included": "Qu'est-ce qui est inclus ?",
      "popular-plan": "Populaire"
    },
    "about-us": {
      "title": "À propos de nous",
      "intro": "Goodchart est né en 2023 avec pour mission de transformer votre expérience d'achat de vêtements. Notre équipe de passionnés de mode, de designers et d'experts techniques est là pour vous aider à trouver des vêtements qui mettent réellement votre corps en valeur. Grâce à notre interface conviviale et à nos algorithmes avancés, nous proposons des recommandations personnalisées basées sur vos mensurations, votre style et votre mode de vie.",
      "community": "Dites adieu aux compromis et bonjour à la confiance et au confort. Rejoignez notre communauté inclusive de clients satisfaits et embarquez pour une expérience d'achat joyeuse avec Goodchart.",
      "tagline": "Libérez votre style. Vivez une pure euphorie de la mode.",
      "founders": "Fondateurs",
      "cedric-photo-alt": "Cedric, Co-fondateur et Directeur Produit de Goodchart",
      "nick-photo-alt": "Nick, Co-fondateur et Directeur des Opérations de Goodchart",
      "quentin-photo-alt": "Quentin, Directeur des Technologies de l'Information de Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Co-fondateur et Directeur Produit de Goodchart",
      "nick": "Nick",
      "nick-role": "Co-fondateur et Directeur des Opérations de Goodchart",
      "quentin": "Quentin",
      "quentin-role": "Directeur des Technologies de l'Information de Goodchart"
    },
    "contact": {
      "title": "Contactez-nous",
      "lets-talk": "Discutons",
      "subtitle": "Remplissez le formulaire et notre équipe vous contactera par e-mail.",
      "first-name": "Prénom",
      "first-name-required": "Le prénom est requis",
      "last-name": "Nom",
      "last-name-required": "Le nom est requis",
      "email": "E-mail",
      "email-required": "L'e-mail est requis",
      "email-invalid": "Veuillez saisir une adresse e-mail valide",
      "message": "Message",
      "message-required": "Le message est requis",
      "sending": "Envoi en cours...",
      "send": "Envoyer",
      "success": "Votre formulaire a été envoyé à notre équipe !"
    },
    "email-unsubscribe": {
      "title": "Abonnement e-mail",
      "unsubscribe-confirm": "Êtes-vous sûr de vouloir vous désabonner de notre liste de diffusion ?",
      "unsubscribe-info": "En vous désabonnant, vous ne recevrez plus de mises à jour, de newsletters ni d'offres spéciales de notre part.",
      "cancel": "Annuler",
      "confirm-unsubscription": "Confirmer le désabonnement",
      "resubscribe-confirm": "Souhaitez-vous vous réabonner à notre liste de diffusion ?",
      "resubscribe-info": "Restez informé de nos dernières actualités, offres exclusives et nouveautés passionnantes.",
      "resubscribe": "Se réabonner",
      "unsubscribe-success": "Votre e-mail a été désabonné avec succès",
      "unsubscribe-error": "Un problème est survenu lors du désabonnement de votre e-mail",
      "resubscribe-success": "Votre e-mail a été réabonné avec succès",
      "resubscribe-error": "Un problème est survenu lors du réabonnement de votre e-mail"
    },
    "back-to-stock": {
      "notify-me-product": "Soyez informé pour le produit {{title}} - {{variant}}"
    },
    "help": {
      "title": "Centre d'aide",
      "description": "Des guides pour configurer et utiliser Goodchart sur votre boutique Shopify.",
      "search": "Rechercher dans les articles d'aide",
      "loading": "Chargement…",
      "load-failed": "Le centre d'aide n'a pas pu être chargé. Veuillez réessayer dans un instant.",
      "no-results": "Aucun article ne correspond à votre recherche.",
      "no-articles": "Il n'y a pas encore d'articles d'aide.",
      "topics": {
        "getting-started": "Premiers pas",
        "size-charts": "Guides des tailles",
        "table-charts": "Tableaux",
        "assigning-products": "Attribuer des produits",
        "storefront-display": "Affichage en boutique",
        "chart-import": "Importer des guides",
        "size-recommendations": "Recommandations de taille",
        "plans-billing": "Forfaits et facturation",
        "troubleshooting": "Dépannage"
      },
      "back": "Retour au centre d'aide",
      "browse": "Parcourir le centre d'aide",
      "not-found": {
        "title": "Article introuvable",
        "description": "Cet article n'existe pas ou n'est plus disponible."
      },
      "updated": "Dernière mise à jour : {{date}}",
      "related": "Plus sur {{topic}}",
      "contact": {
        "title": "Besoin d'aide supplémentaire ?",
        "description": "Envoyez-nous un message et notre équipe vous répondra par e-mail. Si l'application Goodchart est installée, vous pouvez aussi poser votre question dans son chat d'assistance.",
        "link": "Nous contacter"
      },
      "article-load-failed": "Cet article n'a pas pu être chargé. Veuillez réessayer dans un instant."
    }
  },
  "error": {
    "error-occurred": "Erreur!",
    "failed-to-subscribe-to-this-product": "Échec de l'abonnement à ce produit !",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Échec de l'obtention de votre recommandation de taille, veuillez réessayer plus tard"
  },
  "common": {
    "close": "Fermer"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Trouvez votre meilleure taille",
        "subtitle": "Quelques informations rapides pour un meilleur ajustement",
        "shopping-for": "VOUS ACHETEZ POUR",
        "gender-women": "Femme",
        "gender-men": "Homme",
        "gender-other": "Autre",
        "measurements": "MESURES",
        "height": "Taille",
        "height-required": "La taille est requise",
        "height-min": "La taille minimale est 1",
        "weight": "Poids",
        "weight-required": "Le poids est requis",
        "weight-min": "Le poids minimal est 1",
        "preferred-fit": "Ajustement préféré",
        "continue": "Continuer"
      },
      "result": {
        "suggested-size": "Taille suggérée :",
        "no-fit": "Malheureusement, il semble que nous n'ayons pas de taille idéale pour le moment. Nous vous recommandons de revenir plus tard pour plus d'options.",
        "verdict": "Verdict :",
        "similar-variants": "Variantes similaires :",
        "proceed": "Choisir cette variante",
        "estimate-disclaimer": "(Estimation basée sur la marque et les informations de l'utilisateur, les résultats peuvent varier.)",
        "back": "Retour"
      }
    },
    "footer": {
      "terms": "Conditions",
      "privacy": "Confidentialité",
      "help-center": "Centre d'aide",
      "blog": "Blog",
      "about": "À propos",
      "contact-us": "Nous contacter"
    },
    "conversion-table": {
      "description": "Selon la coupe, de légères différences de mesure peuvent apparaître. Trouvez votre taille correcte dans le tableau ci-dessous.",
      "size": "Taille"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Prévenez-moi quand c'est disponible",
      "notify-me": "Prévenez-moi",
      "out-of-stock": "Rupture de stock"
    },
    "restock-form": {
      "your-name": "Votre nom",
      "your-email": "Votre adresse e-mail",
      "email-required": "L'e-mail est requis",
      "subscribing": "Inscription...",
      "notify-me": "PRÉVENEZ-MOI",
      "agree-terms": "En continuant, vous acceptez nos",
      "terms-privacy": "Conditions générales et politique de confidentialité",
      "news-opt-in": "Je souhaite recevoir des informations sur les nouveautés et autres contenus inspirants (facultatif)"
    },
    "back-to-stock-result": {
      "new-subscription": "Merci, nous vous enverrons un e-mail lorsque la taille <span class=\"font-bold\">{{name}}</span> sera disponible.",
      "existing-subscription": "Nous avons bien reçu votre e-mail ! Nous vous préviendrons dès que la taille <span class=\"font-bold\">{{name}}</span> sera de nouveau en stock.",
      "back-to-collection": "Retour à la collection"
    },
    "chart": {
      "find-your-size": "Trouvez votre taille",
      "size-guide": "Guide des tailles",
      "recommendation": "Recommandation",
      "body-measurements": "MENSURATIONS DU CORPS",
      "model-measurements": "MENSURATIONS DU MANNEQUIN",
      "model-description": "Le mannequin {{name}} mesure {{height}} cm et porte la taille {{variant}}.",
      "size-conversion": "CONVERSION DES TAILLES"
    },
    "landing": {
      "learn": "Apprendre",
      "learn-more": "En savoir plus",
      "blog": "Blog",
      "blog-description": "Découvrez les dernières annonces, mises à jour produit et plus encore",
      "help-center": "Centre d'aide",
      "help-center-description": "Premiers pas, articles pratiques et instructions étape par étape",
      "demo": "Démo",
      "demo-description": "Voyez les widgets Goodsize en action sur notre boutique d'exemple",
      "services": "SERVICES",
      "contact": "Contact",
      "privacy": "Confidentialité",
      "goodsize": "Goodsize",
      "goodsize-description": "Découvrez notre solution d'ajustement pour votre entreprise",
      "goodchart": "Goodchart",
      "goodchart-description": "Guide des tailles visuel pour booster la conversion"
    },
    "product-variant-completer": {
      "title": "Choisissez vos options",
      "body": "Sélectionnez votre {{option}} pour continuer.",
      "body-multiple": "Sélectionnez les options restantes pour continuer.",
      "body-notify": "Quelle {{option}} devons-nous surveiller pour vous ?",
      "confirm": "Continuer",
      "cancel": "Annuler",
      "empty": "Cette combinaison n'est pas disponible."
    },
    "checkout-variant": {
      "label": "Vous achetez {{variant}}",
      "aria-label": "Modifier la variante achetée",
      "sold-out": "épuisé"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
